import React, {useContext} from "react";
import { Callback } from "react-oidc";
import {userContext} from "./../../UserContext";
import {appContext} from "./../../AppContext";
import { useFetch } from '../../Utils/Hooks/useFetch';

import { useHistory } from "react-router-dom";

export default function CallbackPage() {
    const [userState, userDispatch] = useContext(userContext);
    // eslint-disable-next-line
    const [appState, appDispatch] = useContext(appContext);
    const history = useHistory();
    const [doFetch] = useFetch();

    return (
        <Callback
        onSuccess={() => {
            doFetch('/user/current')
                .then(response => {
                    if(response.isSuccess) {
                        userDispatch({ type: "LOGGEDIN" })
                        appDispatch({ type: "SETUSER", payload: response.result })
                        return;
                    }
                })
                history.go(-2)
            }}
            userManager={userState.userManager}
        />
    );
}
